import {pageInfo, initEdit, addData, editData, cancelData, templateSystemColumn, importCustomerTemplate, selectSmBaseDtByDataType} from './../api';
import {listShipper, listTemplateTypeCode} from "../../../../api";
const importTemplateSettings = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addDataObj: null,
    editDataObj: null,
    deleteDataObj: null,
    initPageObj: null,
    initEditObj: null,
    exportDataObj: null,
    importDataObj: null,
    downLoadTemplateObj: null,
    companyObj: null,
    carrierObj: null,
    shipperObj: null,
    templateObj: null,
    templateSysColumnObj: null,
    importCustomerObj: null,
    smbaseInfoObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item=> ({
        ...item,
        btns:[{disabled: item.deprecatedFlag == '1' ? true : false},{disabled: item.deprecatedFlag == '1' ? true : false}]}));
    },
    INIT_PAGE(state, data) {
      state.initPageObj = data.obj || {};
    },
    INIT_EDIT(state, data) {
      state.initEditObj = data;
    },
    ADD_DATA(state, data) {
      state.addDataObj = data;
    },
    EDIT_DATA(state, data) {
      state.editDataObj = data;
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj;
    },
    LIST_TEMPLATE_TYPE(state, data) {
      state.templateObj = data.obj;
    },
    TEMPLATE_SYSTEM_COLUMN(state, data) {
      state.templateSysColumnObj = data.obj;
    },
    IMPORT_CUSTOMER_TEMPLATE(state, data) {
      state.importCustomerObj = data;
    },
    SELECT_SM_BASE_DT_BY_DATA_TYPE(state, data) {
      state.smbaseInfoObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({ commit }, obj) {
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initEdit({ commit }, obj) {
      let resp = await initEdit(obj);
      commit('INIT_EDIT', resp);
    },
    //新增保存事件
    async addData({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //修改保存事件
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async cancelData({ commit }, obj) {
      let resp = await cancelData(obj);
      commit('DELETE_DATA', resp);
    },
    //货主
    async listShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    //模版类型
    async listTemplateTypeCode({ commit }, obj) {
      let resp = await listTemplateTypeCode(obj);
      commit('LIST_TEMPLATE_TYPE', resp);
    },
    //根据模版类型编码查询系统表字段
    async templateSystemColumn({ commit }, obj) {
      let resp = await templateSystemColumn(obj);
      commit('TEMPLATE_SYSTEM_COLUMN', resp);
    },
    //选择文件解析
    async importCustomerTemplate({ commit }, obj) {
      let resp = await importCustomerTemplate(obj);
      commit('IMPORT_CUSTOMER_TEMPLATE', resp);
    },
    //查询常量明细
    async selectSmBaseDtByDataType({ commit }, obj) {
      let resp = await selectSmBaseDtByDataType(obj);
      commit('SELECT_SM_BASE_DT_BY_DATA_TYPE', resp);
    },
  }
}
export default importTemplateSettings



// WEBPACK FOOTER //
// ./src/page/configurationCenter/importTemplateSettings/store/importTemplateSettings.store.js